import { Carousel, Skeleton } from 'antd'
import { RecommendedLeadChart } from './RecommendedLeadChart'
import { useNavigate } from 'react-router-dom'
import { IRecommendedCampaign } from '@forwardflow/types'
import CampaignService from '@forwardflow/services/CampaignService'

interface RecommendedLeadProps {
   recommendedCampaigns: IRecommendedCampaign[]
}

export const RecommendedLead: React.FC<RecommendedLeadProps> = ({
   recommendedCampaigns,
}) => {
   const bgColors = ['bg-primary', 'bg-teal-300', 'bg-sky-400']
   const highlightBgColors = ['bg-primary-dark', 'bg-teal-600', 'bg-sky-600']
   const navigate = useNavigate()

   const handleCampaignCreation = async (title: string) => {
      if (title) {
         try {
            const responseActiveLeadSource: any =
               await CampaignService.createActiveLeadSource(title as string)
            if (responseActiveLeadSource) {
               const campaignName = responseActiveLeadSource.campaignName
               const campaignId = responseActiveLeadSource.id
               navigate(
                  `/campaign/${encodeURIComponent(
                     campaignId
                  )}/phone-number?campaignName=${campaignName}`
               )
            }
         } catch (error) {
            console.error('Error creating campaign:', error)
         }
      }
   }

   return (
      <>
         {recommendedCampaigns.length === 0 && (
            <div className="relative h-[188px] overflow-hidden rounded-md flexc bg-">
               <Skeleton active />
            </div>
         )}
         <div
            className={`relative overflow-hidden  rounded-md  border-white/10 ${
               recommendedCampaigns.length !== 0 ? ' border' : ''
            }`}
         >
            <Carousel className="!text-white" autoplay autoplaySpeed={5000}>
               {recommendedCampaigns &&
                  recommendedCampaigns?.map((campaign: any, index: number) => (
                     <div
                        className={`relative p-4 ${
                           bgColors[index % bgColors.length]
                        }`}
                        key={index}
                     >
                        <div className="relative flex items-center justify-between">
                           <p className="font-medium">{campaign?.leadSource}</p>
                           <button
                              onClick={() => {
                                 handleCampaignCreation(campaign?.leadSource)
                              }}
                              className={`!w-[175px] !text-white h-10 flexc  ${
                                 highlightBgColors[
                                    index % highlightBgColors.length
                                 ]
                              } hover:!opacity-80  transition-all !rounded !mt-0 font-medium border-none`}
                           >
                              Activate
                           </button>
                        </div>
                        <p className="px-3 py-1 bg-black/30 rounded text-[10px] font-semibold inline-block z-10 relative">
                           RECOMMENDED
                        </p>
                        <div className="absolute bottom-0 left-0 right-0 w-full">
                           <RecommendedLeadChart
                              index={index}
                              totalLeads={campaign?.totalLeads}
                              appointments={campaign?.appointments}
                           />
                        </div>

                        <p className="mt-7 mb-2 text-[20px] font-semibold z-10 relative">
                           {(
                              (campaign?.appointments / campaign?.totalLeads) *
                                 100 +
                              40
                           ).toFixed(1)}
                           %
                        </p>
                        <p className="text-white/70 text-[12px] z-10 relative">
                           Projected increase in Appointment rate
                        </p>
                     </div>
                  ))}
            </Carousel>
         </div>
      </>
   )
}
